import React from 'react';
import { useModifiedTranslation } from 'hooks/useModifiedTranslation';

/**
 * Skip navigation links for keyboard users.
 * 
 * These links are visually hidden until focused, allowing keyboard users
 * to bypass repetitive navigation and jump directly to main content areas.
 * 
 * Links appear at top-left of viewport when focused via Tab key.
 * Target elements must have matching IDs (e.g., id="main-content").
 * 
 * @see WCAG 2.4.1 Bypass Blocks (Level A)
 */
export const SkipLinks: React.FC = () => {
    const { t } = useModifiedTranslation();

    const linkClasses = `
        sr-only focus:not-sr-only 
        focus:absolute focus:top-2 focus:z-50 
        focus:px-4 focus:py-2 
        focus:bg-primary-600 focus:text-white focus:font-medium 
        focus:rounded focus:shadow-lg 
        focus:outline-none focus:ring-4 focus:ring-yellow-400 focus:ring-offset-2
    `;

    return (
        <div className='skip-links'>
            <a href='#main-content' className={`${linkClasses} focus:left-2`}>
                {t('accessibility.skipToMainContent')}
            </a>
            <a href='#user-menu' className={`${linkClasses} focus:left-40`}>
                {t('accessibility.skipToUserMenu')}
            </a>
        </div>
    );
};
